import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/sysreq/sysreq.component.scss.shim.ngstyle.ts